export default __webpack_public_path__ + "static/media/map.ba0c4eb6.svg";